// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileupload{
    width: 200px;
    height: 46px;
    display: flex;
    align-items: center;
}
.file-upload{
    width: 45px;
    height: 45px;
}
.trash-icon{
    top: 1px;
    right: 1px;
}

@media (min-width: 992px){
    .modal-lg, .modal-xl {
        max-width: 1138px;
    }
}
.btnCancel{
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #EFC427;
    color: #535453;
    margin-right: 8px;
}
.btnSave{
    background: #EFC427;
    border-radius: 4px;
    color: #535453;
}

.file-upload-custom{
    width: 25px;
    height: 25px;
    top: 20%;
    right: 2%;
    background-image: url(/assets/img/icons/image.png);
    background-repeat: no-repeat;
    background-size: contain;
}
.file-upload-custom > input[type=file]{
    opacity: 0;
}
/* public upload block */
.uploadfile-block{
    position: relative;
    width: 85px;
    height: 85px;
    background-color: gainsboro;
}
.uploadfile-block > span{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
}
.uploadfile-block > span > input{
    width: 100%;
    height: 100%;
    opacity: 0;
}
.uploadfile-block > span::before{
    position: absolute;
    top: 25%;
    left: 30%;
    font-size: 47px;
}
.uploadfile-block > span > img{
    width: 100%;
    height: 100%;
}
.uploadfile-block > button{
    width: 100%;
    height: 100%;
}

i {
    font-size: larger;
}

.icon-catalog-file {
    padding-top: 2px;
    margin-right: 3px;
}

.file {
    height: 46px;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px;
    padding: 0.375rem 0.75rem;
    border: 1px solid #BFC9C4 !important;
}

.file-name {
    width: 90%;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/employee-profile/storage-profile-modal/storage-profile-modal.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,kDAAkD;IAClD,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IAGT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AALtB;AAOA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAAA,o0HAAo0H","sourcesContent":[".fileupload{\n    width: 200px;\n    height: 46px;\n    display: flex;\n    align-items: center;\n}\n.file-upload{\n    width: 45px;\n    height: 45px;\n}\n.trash-icon{\n    top: 1px;\n    right: 1px;\n}\n\n@media (min-width: 992px){\n    .modal-lg, .modal-xl {\n        max-width: 1138px;\n    }\n}\n.btnCancel{\n    background: #FFFFFF;\n    border-radius: 4px;\n    border: 1px solid #EFC427;\n    color: #535453;\n    margin-right: 8px;\n}\n.btnSave{\n    background: #EFC427;\n    border-radius: 4px;\n    color: #535453;\n}\n\n.file-upload-custom{\n    width: 25px;\n    height: 25px;\n    top: 20%;\n    right: 2%;\n    background-image: url(/assets/img/icons/image.png);\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.file-upload-custom > input[type=file]{\n    opacity: 0;\n}\n/* public upload block */\n.uploadfile-block{\n    position: relative;\n    width: 85px;\n    height: 85px;\n    background-color: gainsboro;\n}\n.uploadfile-block > span{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n.uploadfile-block > span{\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n.uploadfile-block > span > input{\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n}\n.uploadfile-block > span::before{\n    position: absolute;\n    top: 25%;\n    left: 30%;\n    font-size: 47px;\n}\n.uploadfile-block > span > img{\n    width: 100%;\n    height: 100%;\n}\n.uploadfile-block > button{\n    width: 100%;\n    height: 100%;\n}\n\ni {\n    font-size: larger;\n}\n\n.icon-catalog-file {\n    padding-top: 2px;\n    margin-right: 3px;\n}\n\n.file {\n    height: 46px;\n    justify-content: space-between;\n    border-radius: 8px;\n    border: 1px;\n    padding: 0.375rem 0.75rem;\n    border: 1px solid #BFC9C4 !important;\n}\n\n.file-name {\n    width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
